import { render, staticRenderFns } from "./Lunbo.vue?vue&type=template&id=46680d54&scoped=true&"
import script from "./Lunbo.vue?vue&type=script&lang=js&"
export * from "./Lunbo.vue?vue&type=script&lang=js&"
import style0 from "./Lunbo.vue?vue&type=style&index=0&id=46680d54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46680d54",
  null
  
)

export default component.exports